// API
export const SEARCH_URL = '/search/buildings/'
export const TOKEN_URL = '/api/token/'
export const TOKEN_REFRESH_URL = '/api/token/refresh/'
export const MFA_TOTP_VERIFY_URL = '/api/auth/mfa/totp/verify/'
export const MFA_TOTP_SETUP_BEGIN_URL = '/api/auth/mfa/totp/setup/begin/'
export const MFA_TOTP_SETUP_CONFIRM_URL = '/api/auth/mfa/totp/setup/confirm/'
export const MFA_PASSKEY_AUTH_BEGIN_URL = '/api/auth/mfa/passkey/authenticate/begin/'
export const MFA_PASSKEY_AUTH_COMPLETE_URL = '/api/auth/mfa/passkey/authenticate/complete/'
export const MFA_PASSKEY_REGISTER_BEGIN_URL = '/api/auth/mfa/passkey/register/begin/'
export const MFA_PASSKEY_REGISTER_COMPLETE_URL = '/api/auth/mfa/passkey/register/complete/'
export const MFA_PASSKEYS_URL = '/api/auth/mfa/passkeys/'
export const MFA_STATUS_URL = '/api/auth/mfa/status/'
export const CURRENT_USER_URL = '/users/current/'
export const DATASET_URL = '/datasets/'
export const COMMUNITY_URL = '/communities/'
export const COUNCIL_URL = '/councils/'
export const STATE_ASSEMBLY_URL = '/stateassemblies/'
export const STATE_SENATE_URL = '/statesenates/'
export const ZIPCODE_URL = '/zipcodes/'
export const BOOKMARKS_URL = '/users/bookmarks/'
export const CUSTOM_SEARCHES_URL = '/users/customsearches/'
export const BUILDING_URL = '/buildings/'
export const PROPERTY_URL = '/properties/'
